var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownStroke = function SvgArrowDownStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.47 7.469a.747.747 0 0 0 0 1.06l6 6.002a.75.75 0 0 0 1.06-1.06l-5.47-5.468 5.472-5.472a.75.75 0 0 0-1.06-1.06z"
  })));
};
export default SvgArrowDownStroke;